import { render, staticRenderFns } from "./bulk-message-template-view-all-dialog.vue?vue&type=template&id=08ba9f80&scoped=true&"
import script from "./bulk-message-template-view-all-dialog.vue?vue&type=script&lang=js&"
export * from "./bulk-message-template-view-all-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ba9f80",
  null
  
)

export default component.exports